export default {"src":"/_next/static/media/layer-zero-logo.8e05fe18.svg","height":35,"width":133,"blurWidth":0,"blurHeight":0};